var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Buildings & Landmarks/Building/4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M4.66675 24.5H5.83341M5.83341 24.5V6.7C5.83341 5.5799 5.83341 5.01984 6.0514 4.59202C6.24315 4.21569 6.54911 3.90973 6.92543 3.71799C7.35326 3.5 7.91331 3.5 9.03341 3.5H18.9668C20.0869 3.5 20.6469 3.5 21.0747 3.71799C21.4511 3.90973 21.757 4.21569 21.9488 4.59202C22.1667 5.01984 22.1667 5.57989 22.1667 6.7V24.5M5.83341 24.5H22.1667M22.1667 24.5H23.3334",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M9.33325 9.3335H11.6666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14_2",
    d: "M9.33325 14H11.6666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M9.33325 18.6665H11.6666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14_3",
    d: "M16.3333 9.3335H18.6666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14_4",
    d: "M16.3333 14H18.6666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M16.3333 18.6665H18.6666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.0e8a8d4b10fd31e47f4e1d56785c5369.svg";
export { ForwardRef as ReactComponent };